import { render } from "./NonHeaderFooterLayout.vue?vue&type=template&id=5b1c5aea"
import script from "./NonHeaderFooterLayout.vue?vue&type=script&lang=js"
export * from "./NonHeaderFooterLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__